export const authorStyles = {
    fontSize: '1rem', 
    fontWeight: 'bold', 
    color: '#5043df',
    padding: 3
}

export const commentArticleStyle = {
    animation: 'jumpIn .75s', 
    display: 'flex', 
    marginBottom: 10, 
    marginTop: 5,
    backgroundColor: 'var(--background-color)',
    padding: 10,
}